import { AdminLoginPage, AdminResetPasswordPage } from '../../common';
import { Route, Switch } from 'react-router-dom';
import { AdminChangePasswordPage } from '../../common';
import { AdminShell } from '../admin-shell';
import React from 'react';

export const AdminAppRoutes: React.FunctionComponent = (): React.ReactElement => {
  return (
    <Switch>
      <Route exact path="/admin/login" component={AdminLoginPage} />
      <Route exact path="/admin/reset" component={AdminResetPasswordPage} />
      <Route
        exact
        path="/admin/reset/:token"
        component={AdminChangePasswordPage}
      />
      <Route component={AdminShell} />
    </Switch>
  );
};
